function toggleMoreInfo(kc) {
    /* var boxPar = kc.parentElement.parentElement;
      if (boxPar.getElementsByClassName('cabinetsOpt')[0].checked == true || boxPar.getElementsByClassName('counterOpt')[0].checked == true || boxPar.getElementsByClassName('floorOpt')[0].checked == true){
          boxPar.parentElement.parentElement.getElementsByClassName('allInfo')[0].classList.add('showInfo');   
      }else{
          boxPar.parentElement.parentElement.getElementsByClassName('allInfo')[0].classList.remove('showInfo');
      }
      */
}

function toggleCatalogAddress(kc, er) {
    kc.parentElement.parentElement.parentElement.parentElement.getElementsByClassName(
        "etcPrintCatFields",
    )[0].style.display = er;
}


//ETC's valifate 5 0r 9 digit zip
// function validateZip(z) {
//   return /^[0-9]{5}(?:-[0-9]{4})?$/.test(z);
// }

function validateZip(z) {
    return /^[0-9]{5}$/.test(z);
}

async function botCheck(form) {
    let stopBotCat = form["job-name"].value;
    if (stopBotCat != null && stopBotCat != "") {
        let formData = new FormData();
        let formElements = form.elements;
        for (let i = 0; i < formElements.length; i++) {
            let element = formElements[i];
            let name = element.name;
            let value = element.value;
            formData.append(name, value);
        }
        console.log("bot detected");
        let formLeadSource = document.querySelector(".formSource").value;
        if (
            !formData.get("leadsource") ||
            formData.get("leadsource").trim() === ""
        ) {
            formData.set("leadsource", formLeadSource);
        }
        $.ajax({
            url: "https://formscabinetstogo.com/bot_form.php",
            method: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                console.log("Bot data processed successfully");
            },
            error: function (xhr, status, error) {
                console.log("Error processing bot data: ", error);
            },
        });
        return false;
    } else {
        let formCheck = etcStoreValidate(form);
        return formCheck;
    }
}

function botCheckHammer(form) {
    let stopBotHammer = form["job-title"].value;
    if (stopBotHammer != null && stopBotHammer != "") {
        console.log("bot detected");
        let formData = new FormData();
        let formElements = form.elements;
        for (let i = 0; i < formElements.length; i++) {
            let element = formElements[i];
            let name = element.name;
            let value = element.value;
            formData.append(name, value);
        }
        let formLeadSource = document.querySelector(".formSource").value;
        if (
            !formData.get("leadsource") ||
            formData.get("leadsource").trim() === ""
        ) {
            formData.set("leadsource", formLeadSource);
        }
        $.ajax({
            url: "https://formscabinetstogo.com/bot_form.php",
            method: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                console.log("Bot data processed successfully");
            },
            error: function (xhr, status, error) {
                console.log("Error processing bot data: ", error);
            },
        });
        return false;
    } else {
        etcStoreValidate(form);
    }
}

// Simple validation function for newsletter form
function validateNewsletterForm(form) {
    const email = form.querySelector('input[name="email"]').value.trim();
    const zipcode = form.querySelector('input[name="zipcode"]').value.trim();
    // const honeypot = form.querySelector("#gotchaBot").value;
    // const loadTime = form.querySelector("#formLoadTime").value;
    // const submitTime = Date.now();
    // const timeDiff = submitTime - loadTime;

    // // Check honeypot
    // if (honeypot !== "") {
    //     console.log("Bot detected (honeypot filled)");
    //     return false;
    // }

    // // Check if submitted too fast
    // if (timeDiff < 3000) {
    //     console.log("Bot detected (too fast)");
    //     return false;
    // }

    // Validate email
    if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        alert("Please enter a valid email address.");
        form.querySelector('input[name="email"]').classList.add("failed");
        return false;
    }

    // Validate zip code
    if (!zipcode || !zipcode.match(/^\d{5}$/)) {
        alert("Please enter a valid 5-digit zip code.");
        form.querySelector('input[name="zipcode"]').classList.add("failed");
        return false;
    }

    return true;
}

function etcStoreValidate(xf) {
    // console.log("xf ",xf)
    var vFirst = xf["firstname"];
    var vLast = xf["lastname"];
    var vPhone = xf["phone"];
    var vEmail = xf["email"];
    var vZip = xf["zipcode"];
    var vCity = xf["city"];
    var vAddress = xf["address"];
    var vState = xf["state"];
    var vCatalog = xf["custentity_ctg_web_catalog_type"];
    var vCompany = xf["companyname"];
    var vHeard = xf["custentity18"];
    var vBestTime = xf['custentity_timeandday']
    var vAboutBus = xf['custentity_aboutbusiness']
    var vCustNum = xf['custentity_custnumber']
    var vAltNames = xf['custentity_altnames']
    var vProjectedBus = xf['custentity_theybusiness']

    const sanitizer = new Sanitizer();
    sanitizer.removeUnsafe()
    function sanitize(valueDiv){
        let value = valueDiv.value
        const scratch = document.createElement('div');
        scratch.setHTML(value, { sanitizer });
        let clean = scratch.innerHTML
        valueDiv.value = clean.trim()
        // console.log("valueDiv ", valueDiv.value)
    }

    if(vFirst.value != ''){
        sanitize(vFirst)
    }
    if(vLast.value != ''){
        sanitize(vLast)
    }
    if(vAddress && vAddress.value != ''){
        sanitize(vAddress)
    }
    if(vCity.value != ''){
        sanitize(vCity)
    }
    if(vCompany){
        sanitize(vCompany)
    }
    if(vAboutBus){
        sanitize(vAboutBus)
    }
    if(vCustNum){
        sanitize(vCustNum)
    }
    if(vAltNames){
        sanitize(vAltNames)
    }
    if(vProjectedBus){
        sanitize(vProjectedBus)
    }

    // urlFormatting(xf);
    let phoneValue = vPhone.value
    if (phoneValue != null || phoneValue != "") {
        const re = /^(\(\d{3}\)\s*\d{3}-\d{4}|\d{10}|\d{3}-\d{3}-\d{4})$/;
        let testRes = re.test(phoneValue);
        if (testRes) {
            vPhone.classList.remove("failed");
        } else {
            vPhone.classList.add("failed");
            return false
        }
    }
    let emailValue = vEmail.value
    if (emailValue != null || emailValue != '') {
        let isValid =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
        if (isValid) {
            vEmail.classList.remove("failed");
        } else {
            vEmail.classList.add("failed");
            return false
        }
    }
    let zipValue = vZip.value
    if (zipValue != null || zipValue != '') {
        let isValid = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipValue);
        if (isValid) {
            vZip.classList.remove("failed");
        } else {
            vZip.classList.add("failed");
            return false
        }
    }
    if(vHeard){
        let heardValue = vHeard.value
        if (heardValue === '') {
            vHeard.classList.add("failed");
            alert("Please select how you heard about us.")
            return false
        } else {
            vHeard.classList.remove("failed");
        }
    }
    if(vBestTime){
        sanitize(vBestTime)
    }
    return true
}

function urlFormatting(xf) {
    //check if subscribed or not and place value
    if (xf.getElementsByClassName("subscribeBox")[0] != null) {
        if (xf.getElementsByClassName("subscribeBox")[0].checked == false) {
            xf.getElementsByClassName("subscribeBox")[0].type = "hidden";
            xf.getElementsByClassName("subscribeBox")[0].value = "F";
        }
    }
    //check if pro or not and place value
    if (xf.getElementsByClassName("ProOption")[0] != null) {
        if (xf.getElementsByClassName("ProOption")[0].checked == true) {
            xf.getElementsByClassName("ProOptionValue")[0].value = "CAM19 Pro Lead";
        } else {
            xf.getElementsByClassName("ProOptionValue")[0].value =
                xf.parentElement.parentElement.parentElement.parentElement.children[3].value
        }
    }
    //check what project they selected and place value
    if (xf.getElementsByClassName("projectValue")[0] != null) {
        var projectValue = xf.getElementsByClassName("projectValue")[0];
        var kitchenOpt = xf.getElementsByClassName("kitchenOpt")[0];
        var bathOpt = xf.getElementsByClassName("bathOpt")[0];
        var closetOpt = xf.getElementsByClassName("closetOpt")[0];
        var otherOpt = xf.getElementsByClassName("otherOpt")[0];

        if (kitchenOpt.checked == true) {
            if (bathOpt.checked == true) {
                if (closetOpt.checked == true) {
                    if (otherOpt.checked == true) {
                        projectValue.value =
                            kitchenOpt.value +
                            ", " +
                            bathOpt.value +
                            ", " +
                            closetOpt.value +
                            ", " +
                            otherOpt.value;
                    } else {
                        projectValue.value =
                            kitchenOpt.value + ", " + bathOpt.value + ", " + closetOpt.value;
                    }
                } else if (otherOpt.checked == true) {
                    projectValue.value =
                        kitchenOpt.value + ", " + bathOpt.value + ", " + otherOpt.value;
                } else {
                    projectValue.value = kitchenOpt.value + ", " + bathOpt.value;
                }
            } else if (closetOpt.checked == true) {
                if (otherOpt.checked == true) {
                    projectValue.value =
                        kitchenOpt.value + ", " + closetOpt.value + ", " + otherOpt.value;
                } else {
                    projectValue.value = kitchenOpt.value + ", " + closetOpt.value;
                }
            } else if (otherOpt.checked == true) {
                projectValue.value = kitchenOpt.value + ", " + otherOpt.value;
            } else {
                projectValue.value = kitchenOpt.value;
            }
        } else if (bathOpt.checked == true) {
            if (closetOpt.checked == true) {
                if (otherOpt.checked == true) {
                    projectValue.value =
                        bathOpt.value + ", " + closetOpt.value + ", " + otherOpt.value;
                } else {
                    projectValue.value = bathOpt.value + ", " + closetOpt.value;
                }
            } else if (otherOpt.checked == true) {
                projectValue.value = bathOpt.value + ", " + otherOpt.value;
            } else {
                projectValue.value = bathOpt.value;
            }
        } else if (closetOpt.checked == true) {
            if (otherOpt.checked == true) {
                projectValue.value = closetOpt.value + ", " + otherOpt.value;
            } else {
                projectValue.value = closetOpt.value;
            }
        } else if (otherOpt.checked == true) {
            projectValue.value = otherOpt.value;
        } else {
            projectValue.value = "Not Specified";
        }
    }

    if (xf.getElementsByClassName("interestedValue")[0] != null) {
        var interestedValue = xf.getElementsByClassName("interestedValue")[0];
        var cabinetsOpt = xf.getElementsByClassName("cabinetsOpt")[0];
        var counterOpt = xf.getElementsByClassName("counterOpt")[0];

        if (cabinetsOpt.checked == true) {
            if (counterOpt.checked == true) {
                interestedValue.value = cabinetsOpt.value + " and " + counterOpt.value;
            } else {
                interestedValue.value = cabinetsOpt.value + " Only";
            }
        } else if (counterOpt.checked == true) {
            interestedValue.value = counterOpt.value + " Only";
        }
    }
    //check what areas make up their project and whatnot
    if (xf.getElementsByClassName("projectMakeup")[0] != null) {
        var projectMakeup = xf.getElementsByClassName("projectMakeup")[0];
        var projClosetsOpt = xf.getElementsByClassName("projClosetsOpt")[0];
        var projCabinetOpt = xf.getElementsByClassName("projCabinetOpt")[0];
        var projKitchenOpt = xf.getElementsByClassName("projKitchenOpt")[0];
        var projBathOpt = xf.getElementsByClassName("projBathOpt")[0];
        var projFlooringOpt = xf.getElementsByClassName("projFlooringOpt")[0];
        var projOtherOpt = xf.getElementsByClassName("projOtherOpt")[0];
        var ffProjects = "";

        if (projClosetsOpt.checked == true) {
            ffProjects = ffProjects + projClosetsOpt.value + ", ";
        }
        if (projCabinetOpt.checked == true) {
            ffProjects = ffProjects + projCabinetOpt.value + ", ";
        }
        if (projKitchenOpt.checked == true) {
            ffProjects = ffProjects + projKitchenOpt.value + ", ";
        }
        if (projBathOpt.checked == true) {
            ffProjects = ffProjects + projBathOpt.value + ", ";
        }
        if (projFlooringOpt.checked == true) {
            ffProjects = ffProjects + projFlooringOpt.value + ", ";
        }
        if (projOtherOpt.checked == true) {
            ffProjects = ffProjects + projOtherOpt.value + ", ";
        }

        projectMakeup.value = ffProjects;
    }

}

